import { inject, Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { ApiService } from '@shared/services/api.service';
import { MainQuery } from '@shared/store/main/main.query';
import { OrganizationQuery } from '@shared/store/organization/organization.query';

import { InvoiceState, InvoiceStore } from './invoice.store';

@Injectable({ providedIn: 'root' })
export class InvoiceQuery extends QueryEntity<InvoiceState> {
  private apiService = inject(ApiService);
  private mainQuery = inject(MainQuery);
  private organizationQuery = inject(OrganizationQuery);

  protected store: InvoiceStore;

  constructor() {
    const store = inject(InvoiceStore);

    super(store);

    this.store = store;
  }

  async downloadINV(
    id: string
  ): Promise<{ data: null | string; errors: string[]; success: boolean }> {
    const emptyReturn = {
      data: null,
      errors: ['Unexpected Error!'],
      success: false,
    };

    const inv = this.getEntity(id);

    if (!inv) {
      return emptyReturn;
    }

    const org = this.organizationQuery.getEntity(inv.organization.id);

    if (!org) {
      return emptyReturn;
    }

    const currentTrial = this.mainQuery.getSelectedTrial();

    if (!currentTrial) {
      return emptyReturn;
    }

    const { data, errors, success } = await this.apiService.getS3ZipFile(
      this.getFilePath(inv.organization.id, inv.id)
    );

    if (success && data) {
      // [insert trial name]_[insert vendor name]_Change Order [insert Change Order #]_[insert date created YYYY.MM.DD]
      const fileName = `${currentTrial.short_name}_${org.name}_${inv.invoice_no}_${(
        inv.invoice_date || ''
      ).slice(0, 10)}`;

      await this.apiService.downloadZipOrFile(data, fileName);
    }

    return { data, errors, success };
  }

  getFilePath(org_id: string, id: string) {
    const trial_id = this.mainQuery.getValue().trialKey;

    return `trials/${trial_id}/vendors/${org_id}/invoices/${id}/`;
  }
}
